import { Component } from '@angular/core';

@Component({
  selector: 'app-function-scope',
  templateUrl: './function-scope.component.html',
})
export class FunctionScopeComponent {}
